function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import EventTracker from "../../utils/Tracker/EventTracker";
import filterPayload from "../../utils/Tracker/filterPayload";
import TrackerContext from "./context";
import { jsx as _jsx } from "react/jsx-runtime";
let globalState = {
  getConfig: null,
  source: null
};
export const trackEvent = function () {
  let eventName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Unknown Event';
  let payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let defaultData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  let config = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  const {
    getConfig,
    source
  } = globalState;
  const verifiedPayload = payload !== null ? payload : {};
  if (!eventName || !verifiedPayload || !defaultData || !getConfig) {
    const msg = 'trackEvent missing arguments';
    if (typeof window !== 'undefined' && window.Rollbar) {
      window.Rollbar.error(msg, {
        eventName,
        payload: verifiedPayload
      });
    }
    // eslint-disable-next-line no-console
    return console.error(msg);
  }
  const filteredPayload = filterPayload({
    source,
    payload: verifiedPayload,
    defaultData
  });
  return EventTracker.trackClick(eventName, filteredPayload, _objectSpread(_objectSpread({}, getConfig()), config));
};
const setGlobalState = (getConfig, source) => {
  globalState = {
    getConfig,
    source
  };
};
const Tracker = _ref => {
  let {
    children,
    getConfig,
    source,
    className = '',
    style = {}
  } = _ref;
  useEffect(() => {
    setGlobalState(getConfig, source);
  }, [getConfig, source]);
  const eventTracker = useCallback(function () {
    let eventName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Unknown Event';
    let payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let defaultData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    setGlobalState(getConfig, source);
    trackEvent(eventName, payload, defaultData);
  }, [getConfig, source]);
  return /*#__PURE__*/_jsx("div", {
    className: className,
    style: style,
    children: /*#__PURE__*/_jsx(TrackerContext.Provider, {
      value: eventTracker,
      children: children
    })
  });
};
Tracker.propTypes = {
  /** Children components to be wrapped by Tracker */
  children: PropTypes.node.isRequired,
  /** Source identifier for the event tracker */
  source: PropTypes.string.isRequired,
  /** Function to get configuration settings */
  getConfig: PropTypes.func.isRequired,
  /** Optional class name for styling */
  className: PropTypes.string,
  /** Inline styles for the root element */
  style: PropTypes.object
};
export default Tracker;
//# sourceMappingURL=Tracker.js.map